import syncFields from './_syncfields.js';
import processRendering from './_processrendering/index.js';
import assign from '../_helpers/assign.js';
// rerenders not rendered items in an array
// force rerender when forceRerender event option is truthy
export default function rerender(eventOptions) {
  if (eventOptions === void 0) {
    eventOptions = {};
  }
  syncFields(this);
  var _this$renderIfPossibl = this.renderIfPossible,
    renderIfPossible = _this$renderIfPossibl === void 0 ? true : _this$renderIfPossibl;
  if (renderIfPossible) {
    processRendering({
      self: this,
      eventOptions: assign({
        method: 'rerender',
        added: [],
        removed: []
      }, eventOptions)
    });
  }
  return this;
}